export function formatDuration(duration) {
    const [hStr, mStr] = duration.split(":");
    const h = parseInt(hStr, 10);
    const m = parseInt(mStr, 10);

    let result = "";

    if (!mStr && mStr !== 0) {
        if (h > 0) {
            result += " ";
        }

        return hStr + " minutes";
    }

    if (h > 0) {
        result += h + (h === 1 ? " heure" : " heures");
    }

    if (m > 0) {
        if (h > 0) result += " ";
        result += m + (m === 1 ? " minute" : " minutes");
    }

    if (result === "") {
        result = "0 minute";
    }

    return result;
}

export function timeToMinutes(time) {
    if (!time) return 0;

    // Si la durée est déjà en minutes (nombre)
    if (typeof time === 'number') return time;

    // Si c'est une chaîne "HH:mm"
    if (time.includes(':')) {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + m;
    }

    // Si c'est une chaîne représentant directement des minutes
    return Number(time);
}

export function minutesToTime(minutes) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
}

export function generateTimeSlots(start, end, durationMinutes) {
    const slots = [];
    const [startHour, startMinute] = start.split(":").map(Number);
    const [endHour, endMinute] = end.split(":").map(Number);

    let current = new Date();
    current.setHours(startHour, startMinute, 0, 0);

    const endTime = new Date();
    endTime.setHours(endHour, endMinute, 0, 0);

    while (current <= endTime) {
        const formatted = current.toLocaleTimeString("fr-FR", {
            hour: "2-digit",
            minute: "2-digit",
        });
        slots.push(formatted);
        current = new Date(current.getTime() + durationMinutes * 60000);
    }

    return slots;
}


// export function generateTimeSlots(startTime, endTime, duration) {
//     const slots = [];
//     const start = timeToMinutes(startTime);
//     const end = timeToMinutes(endTime);
//     const step = timeToMinutes(duration);

//     // Vérification des paramètres
//     if (isNaN(start) || isNaN(end) || isNaN(step) || step <= 0) {
//         console.error("Paramètres invalides pour generateTimeSlots", { startTime, endTime, duration });
//         return slots;
//     }

//     for (let time = start; time + step <= end; time += step) {
//         const slotStart = minutesToTime(time);
//         const slotEnd = minutesToTime(time + step);
//         slots.push(`${slotStart} - ${slotEnd}`);
//     }

//     return slots;
// }
